import { CaceisIcons } from "../../icons/caceis-icon/caceis-icon.component";
import { SnackbarVerticalPosition, SnackbarHorizontalPosition, SnackbarTheme } from "./snackbar.component";

export class SnackbarModel {
    duration: number;
    icon: CaceisIcons;
    verticalPosition: SnackbarVerticalPosition;
    horizontalPosition: SnackbarHorizontalPosition;
    snackbarTheme: SnackbarTheme;
    reverse?: boolean;

    constructor(
        public label?: string,
        public onAction?: Function,
        icon?: CaceisIcons,
        duration?: number,
        verticalPosition?: SnackbarVerticalPosition,
        horizontalPosition?: SnackbarHorizontalPosition,
        snackbarTheme?: SnackbarTheme,
        reverse?: boolean,
    ) {
        this.duration = duration || 3000;
        this.icon = icon || CaceisIcons.x;
        this.verticalPosition = verticalPosition || SnackbarVerticalPosition.bottom;
        this.horizontalPosition =
            horizontalPosition || SnackbarHorizontalPosition.center;
        this.snackbarTheme = snackbarTheme || SnackbarTheme.info;
        this.reverse = reverse || false;
    }
}